import { WidgetDefinition } from '@pulse-ui/widget-sdk';

/**
 * Central widget registry
 * All widgets must be registered here to be available
 *
 * Widget apps will override this with their own registry
 * that includes only the widgets they need
 */
export const WIDGET_REGISTRY: Record<string, WidgetDefinition> = {
  // Example widgets - apps should provide their own registry
  // 'chart-widget': {
  //   id: 'chart-widget',
  //   name: 'Price Chart',
  //   description: 'Real-time price charts with multiple timeframes',
  //   category: 'Market Data',
  //   component: lazy(() => import('@pulse-ui/chart-widget')),
  //   icon: 'chart-line',
  // },
};

/**
 * Get a single widget by ID
 */
export function getWidget(widgetId: string): WidgetDefinition | undefined {
  return WIDGET_REGISTRY[widgetId];
}

/**
 * Get all registered widgets
 */
export function getAllWidgets(): WidgetDefinition[] {
  return Object.values(WIDGET_REGISTRY);
}

/**
 * Get widgets grouped by category
 */
export function getWidgetsByCategory(): Record<string, WidgetDefinition[]> {
  const byCategory: Record<string, WidgetDefinition[]> = {};

  Object.values(WIDGET_REGISTRY).forEach((widget) => {
    if (!byCategory[widget.category]) {
      byCategory[widget.category] = [];
    }
    byCategory[widget.category].push(widget);
  });

  return byCategory;
}

/**
 * Register a widget dynamically
 * Useful for apps that want to add widgets at runtime
 */
export function registerWidget(definition: WidgetDefinition): void {
  WIDGET_REGISTRY[definition.id] = definition;
}

/**
 * Register multiple widgets at once
 */
export function registerWidgets(definitions: WidgetDefinition[]): void {
  definitions.forEach((def) => registerWidget(def));
}
